import axios from "axios"
export const varsActions= {
  searchCity: "searchCity",
  closeCity: "closeCity",
  errorNameCity: "errorNameCity",
  resetError: "resetError",
  resetErrorExist: "resetErrorExist"
}

export const searchCity = (city, apiKey) => {
  return (dispatch) => {
    axios.get(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`)
    .then((ciudad) => dispatch({type: varsActions.searchCity, payload: ciudad.data}),
    () => dispatch({type: varsActions.errorNameCity, payload: "City not found, Try it again"}))
  };
};

export const closeCity = (idCity) => {
  return ({type: varsActions.closeCity, payload: idCity})
}

export const resetError = () => {
  return ({type: varsActions.resetError})
}
export const resetErrorExist = () => {
  return ({type: varsActions.resetErrorExist})
}